import axios from 'axios';

const API_SECRET = 'x7Kp9mQ2';

const api = axios.create({
  baseURL: `https://eduportalual.com/backend/api/${API_SECRET}`,
  withCredentials: true, // Enviar cookies automáticamente en cada petición
});

// Inyectar token JWT en cabecera (funciona en desarrollo local con XAMPP)
api.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Si el servidor devuelve 401, limpiar sesión y redirigir al login
api.interceptors.response.use(
  res => res,
  err => {
    if (err.response?.status === 401) {
      localStorage.clear();
      window.location.replace('/#/login');
    }
    return Promise.reject(err);
  }
);

export default api;
